import React, { useState } from 'react';
import { pets, owners, petHistory, petActivities, petDocuments } from '../mock/petsData';
import PetProfileCard from '../components/PetProfileCard';
import PetActivityTimeline from '../components/PetActivityTimeline';

const PetProfilePage = () => {
  const [currentPet] = useState(pets[0]);
  const [activeTab, setActiveTab] = useState('profile');
  const petOwner = owners.find(o => o.id === currentPet.ownerId);

  return (
    <div className="ml-48 p-4">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Perfil de {currentPet.name}</h2>
        <div className="flex border border-gray-300 rounded-md overflow-hidden">
          <button
            onClick={() => setActiveTab('profile')}
            className={`px-4 py-2 ${activeTab === 'profile' ? 'bg-cyan-600 text-white' : 'bg-white'}`}
          >
            Perfil
          </button>
          <button
            onClick={() => setActiveTab('history')}
            className={`px-4 py-2 ${activeTab === 'history' ? 'bg-cyan-600 text-white' : 'bg-white'}`}
          >
            Historial
          </button>
          <button
            onClick={() => setActiveTab('activities')}
            className={`px-4 py-2 ${activeTab === 'activities' ? 'bg-cyan-600 text-white' : 'bg-white'}`}
          >
            Actividades
          </button>
        </div>
      </div>

      {activeTab === 'profile' && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <PetProfileCard 
              pet={currentPet} 
              owner={petOwner} 
              onEdit={() => console.log('Editar mascota')} 
            />
          </div>
          <div>
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
              <h3 className="text-lg font-semibold mb-4">Documentos</h3>
              {petDocuments.filter(d => d.petId === currentPet.id).length > 0 ? (
                <div className="space-y-2">
                  {petDocuments.filter(d => d.petId === currentPet.id).map(doc => (
                    <div key={doc.id} className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                      </svg>
                      <div className="flex-1">
                        <p className="font-medium">{doc.name}</p>
                        <p className="text-sm text-gray-500">Subido el {doc.uploadedAt}</p>
                      </div>
                      <a 
                        href={doc.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-cyan-600 hover:text-cyan-800"
                      >
                        Ver
                      </a>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-500">No hay documentos subidos</p>
              )}
            </div>
          </div>
        </div>
      )}

      {activeTab === 'activities' && (
        <PetActivityTimeline activities={petActivities.filter(a => a.petId === currentPet.id)} />
      )}
    </div>
  );
};

export default PetProfilePage;